import React from 'react';

function ImageElement({ element }) {
  const { content, style = {} } = element;
  
  return (
    <img 
      src={content || 'https://via.placeholder.com/400x300?text=Select+an+image'} 
      alt="Element"
      style={{
        width: '100%',
        height: '100%',
        objectFit: style.objectFit || 'cover',
        borderRadius: style.borderRadius || '0',
        opacity: style.opacity !== undefined ? style.opacity : 1
      }}
    />
  );
}

export default ImageElement; 